import { Button } from '@/components/ui/button';
import { Eye, EyeOff, Route } from 'lucide-react';

interface CorridorControlsProps {
  showCorridors: boolean;
  corridorType: 'RIT' | 'RIH';
  isTimeMachineActive: boolean;
  onToggle: () => void;
  onTypeChange: (type: 'RIT' | 'RIH') => void;
}

export function CorridorControls({
  showCorridors,
  corridorType,
  isTimeMachineActive,
  onToggle,
  onTypeChange
}: CorridorControlsProps) {
  return (
    <>
      <Button variant={showCorridors ? 'default' : 'outline'} size="sm" onClick={onToggle}>
        {showCorridors ? <Eye className="w-4 h-4 mr-1" /> : <EyeOff className="w-4 h-4 mr-1" />}
        Routes
      </Button>

      {showCorridors && (
        <div className="flex gap-1">
          <Button
            variant={corridorType === 'RIT' ? 'default' : 'outline'}
            size="sm"
            onClick={() => onTypeChange('RIT')}
            title={
              isTimeMachineActive ? 'Show what was in transit at selected week' : 'Show current in-transit shipments'
            }>
            <Route className="w-4 h-4 mr-1" />
            In Transit
          </Button>
          <Button
            variant={corridorType === 'RIH' ? 'default' : 'outline'}
            size="sm"
            onClick={() => onTypeChange('RIH')}
            title={isTimeMachineActive ? 'Show all routes used up to selected week' : 'Show all historical routes'}>
            <Route className="w-4 h-4 mr-1" />
            All Routes
          </Button>
        </div>
      )}
    </>
  );
}
